import * as React from 'react';
import { useEffect, useState } from 'react';
import { SelectWidget } from '../../../../../widgets/select/SelectWidget';
import { useSystem } from '../../../../../hooks/useSystem';
import { IntegrationModel, OrganizationModel } from '@journeyapps-platform/lib-journey-core';
import { styled } from '../../../../../theme';
import { GithubAccountType, IntegrationKind } from '@journeyapps-platform/types-cerberus';
import { AdvancedSelect, CommonRepoSelectProps, normaliseRepoName } from '../AdvancedSelect';

export interface GithubReposDropdownWidgetProps {
  integration: IntegrationModel;
  org: OrganizationModel;
  setProperties: (props: { owner?: string; repo?: string; create?: boolean }) => any;
  repo?: string;
  appName: string;
  groupingName: string;
}

export const SimpleSelect: React.FC<CommonRepoSelectProps> = (props) => {
  return (
    <>
      <S.SelectLabel>Select a repository to use</S.SelectLabel>
      <SelectWidget
        onChange={(v) => {
          props.setProperties({
            create: false,
            repo: normaliseRepoName((v as any).value)
          });
        }}
        value={{
          value: props.repo || '',
          label: props.repo || ''
        }}
        placeholder="Select repository"
        options={props.repos || []}
        isLoading={!props.repos}
      />
      <S.Link>
        With GitHub user accounts you can only select existing GitHub repositories. If none of the listed repositories
        are suitable, create a blank repository for this app in GitHub and then return here.
      </S.Link>
    </>
  );
};

export const GithubReposDropdownWidget: React.FC<GithubReposDropdownWidgetProps> = (props) => {
  const system = useSystem();
  const [repos, setRepos] = useState<{ value: string; label: string }[] | null>(null);
  const integrationProps = props.integration.getProperties<IntegrationKind.GitHub>();
  useEffect(() => {
    const client = system.clientProvisioner.provisionProviderClient();
    client
      .getGitHubRepositories({
        org_id: props.org.id,
        github_account: integrationProps.org
      })
      .then((c) => {
        setRepos(
          c.map((repo) => {
            return {
              value: repo.name,
              label: repo.name
            };
          })
        );
      })
      .finally(() => {});
  }, [integrationProps.org]);

  return (
    <S.SelectContainer padTop={true}>
      {integrationProps.account_type === GithubAccountType.User ? (
        <SimpleSelect {...props} repos={repos} />
      ) : (
        <AdvancedSelect {...props} repos={repos} />
      )}
    </S.SelectContainer>
  );
};

namespace S {
  export const SelectContainer = styled.div<{ padTop?: boolean }>`
    width: 100%;
    color: ${(p) => p.theme.text.primary};
    margin-top: ${(p) => (p.padTop ? 16 : 0)}px;
  `;

  export const SelectLabel = styled.div`
    color: ${(p) => p.theme.text.secondary};
    padding-bottom: 8px;
  `;

  export const Link = styled.p`
    padding-top: 16px;
    padding-bottom: 16px;
    color: ${(p) => p.theme.text.primary};
    font-size: 12px;
  `;
}
